import { useContext, useState, useEffect } from "react";
import AdminRoutes from "./AdminRoutes";
import CustomerRoutes from "./CustomerRoutes";
import AuthRoutes from "./AuthRoutes";
import { AuthContext } from "../context/AuthContext";
import ShopRoutes from "./ShopRoutes";
import { NavDrawerProvider } from "../context/NavDrawerContext";
import ShopAccountRoutes from "./ShopAccountRoutes";
import ShopForemanRoutes from "./ShopForemanRoutes";

const ApplicationRoutes = () => {
  const { role, authToken } = useContext(AuthContext);
  if (role === undefined || authToken === undefined) {
    return <div>Loading...</div>;
  }

  switch (role) {
    case "OWNER":
    case "ADMIN":
    case "USER":
      return <CustomerRoutes />;
    case "EZORDER_ADMIN":
      return (
        <NavDrawerProvider>
          <AdminRoutes />
        </NavDrawerProvider>
      );
    case "EZORDER_FOREMAN":
      return <ShopForemanRoutes />;
    case "EZORDER_EMPLOYEE":
      return <ShopRoutes />;
    case "EZORDER_SHOP_ACCOUNT":
      return <ShopAccountRoutes />;
    default:
      return <AuthRoutes />;
  }
};

export default ApplicationRoutes;
